package fr.manyverse.app.infrastructure.image

import fr.manyverse.app.domain.image.ImageOptimizer

expect fun createImageOptimizer(): ImageOptimizer

internal fun toWebpFileName(originalName: String): String {
    val base = originalName.substringBeforeLast('.', originalName).ifBlank { "image" }
    return "$base.webp"
}
